export interface SubmitCompanyInformationDto {
  companyName: string;
  businessName: string;
  companyNationalId: string;
  companyType: string;
  registrationNumber: string;
  gazetteFileUrl?: string;
}

export function toSubmitCompanyInformationFormData(
  dto: SubmitCompanyInformationDto,
): FormData {
  const formData = new FormData();

  formData.append('CompanyName', dto.companyName);
  formData.append('BusinessName', dto.businessName);
  formData.append('CompanyNationalId', dto.companyNationalId);
  formData.append('CompanyType', dto.companyType);
  formData.append('RegistrationNumber', dto.registrationNumber);

  if (dto.gazetteFileUrl) {
    formData.append('GazetteFileUrl', dto.gazetteFileUrl);
  }

  return formData;
}
